import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Tab from '@components/common/tab';

import { useBookmarkStatus } from '@repository/bookmark/useBookmark';
import PositionList from './positionList';
import RecruitmentList from './recruitmentList';
import CompanyList from './companyList';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

export enum ApplyTabEnum {
  ALL = 'ALL',
  WRITING = 'WRITING',
  JOB = 'JOB',
  PROGRESS = 'PROGRESS',
  COMPLETED = 'COMPLETED',
}

interface TitleProps {
  title: string;
  count: number;
  isNew?: boolean;
}

const Title = ({ title, count, isNew }: TitleProps) => {
  return (
    <div className={cx('titleContainer')}>
      <div className={cx('count', { isNew })}>{count}</div>
      <div className={cx('title')}>{title}</div>
    </div>
  );
};

type BookmarkTabType = 'POSITION' | 'JOB' | 'COMPANY';
const ApplyTab = () => {
  const { query, replace } = useRouter();
  const [tabType, setTabType] = useState<BookmarkTabType>((query.tab as BookmarkTabType) ?? 'POSITION');
  const { data } = useBookmarkStatus();

  useEffect(() => {
    if (query.tab) {
      setTabType(query.tab as BookmarkTabType);
    }
  }, [query]);

  const handleTabChange = (tab?: string) => {
    replace({ query: { ...query, tab } }, undefined, { shallow: true });
    setTabType(tab as BookmarkTabType);
  };

  return (
    <Tab className={cx('container')} active={tabType} onTabChange={handleTabChange}>
      <Tab.Item
        title={<Title title="포지션" count={data?.positionCount ?? 0} isNew={false} />}
        index={'POSITION'}
        className={cx('item')}
        activeClassName={cx('active')}
        nonActiveClassName={cx('nonActive')}
      >
        <PositionList />
      </Tab.Item>
      <Tab.Item
        title={<Title title="공고" count={data?.jobPostCount ?? 0} isNew={false} />}
        index={'JOB'}
        className={cx('item')}
        activeClassName={cx('active')}
        nonActiveClassName={cx('nonActive')}
      >
        <RecruitmentList />
      </Tab.Item>
      <Tab.Item
        title={<Title title="관심 기업" count={data?.companyCount ?? 0} isNew={false} />}
        index={'COMPANY'}
        className={cx('item')}
        activeClassName={cx('active')}
        nonActiveClassName={cx('nonActive')}
      >
        <CompanyList />
      </Tab.Item>
    </Tab>
  );
};

export default ApplyTab;
